import React from "react";
import { Edit, SimpleForm, TextInput, Notification, useNotify, Loading, NumberInput, minValue } from "react-admin";
import { validateRequired } from "../../../utils/Validations";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { EditToolBar, CustomBooleanInput } from "../../Signet/util";
import WithProps from "../../Custom/WithProps";
import { CustomSelect } from "../../CustomPricing/util";
import AppMultiSelect from "../../AppMultiSelect/AppMultiSelect";

const useStyles = makeStyles({
    capitalize: {
        textTransform: "capitalize",
        fontWeight: "bold",
    },
    container: {
        width: "100%",
    },
    password: {
        margin: "10px 0",
        minHeight: "50px",
    },
    marginBounds: {
        marginTop: "20px",
    },
    formIterator: {
        "& ul": {
            width: "80%",
            display: "flex",
            justifyContent: "space-between",
        },
    },
});

const CollegiateEngravingEdit = (props) => {
    const classes = useStyles();
    const { permissions } = props;
    const notify = useNotify();

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    const onFailure = (error) => {
        notify(
            error.response.data.message
                ? error.response.data.message
                : "Something went wrong",
            { type: "warning" }
        );
    };

    return (
        <ThemeProvider>
            <Edit
                mutationMode="pessimistic"
                {...props}
                onFailure={onFailure}
                className="overflow-visible"
            >
                <WithProps>
                    {({ record, ...props }) => (
                        <SimpleForm
                            record={record}
                            {...props}
                            undoable={false}
                            toolbar={<EditToolBar delete={true} />}
                        >
                            <Grid
                                container
                                className={classes.container}
                                justify="space-between"
                            >
                                <Grid item xs={5}>
                                    <TextInput source="name" fullWidth validate={validateRequired}/>
                                </Grid>
                                <Grid item xs={5}>
                                    <TextInput source="sku_code"  fullWidth validate={validateRequired}/>
                                </Grid>
                                <Grid item xs={5}>
                                    <CustomBooleanInput source="allow_cerakote" label="Allow Cerakote" fullWidth/>
                                    <CustomBooleanInput source="enabled" label="Enabled" fullWidth/>
                                    <CustomBooleanInput source="allow_on_primary_ring" label="Allow on Primary Ring" fullWidth/>
                                    <CustomBooleanInput source="allow_on_inlay" label="Allow on Inlay" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <CustomBooleanInput source="allow_inside_engraving" label="Allow Inside Engraving" fullWidth/>
                                    <CustomBooleanInput source="allow_inside_cerakote" label="Allow Inside Cerakote" fullWidth/>
                                    <CustomBooleanInput source="has_inside_reversed_option" label="Has Inside Reversed Option" fullWidth/>
                                    <CustomBooleanInput source="has_outside_reversed_option" label="Has Outside Reversed Option" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <NumberInput source="markup" min={0} validate={[validateRequired, minValue(0)]} fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <NumberInput source="inside_minimum_width" min={0} validate={[validateRequired, minValue(0)]} label="Inside Minimum Width" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <NumberInput source="outside_minimum_width" min={0} validate={[validateRequired, minValue(0)]} label="Outside Minimum Width" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <NumberInput source="outside_live_tool_laser" min={0} validate={[validateRequired, minValue(0)]} label="Outside Live Tool Laser" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <NumberInput source="inside_live_tool_laser" min={0} validate={[validateRequired, minValue(0)]} label="Inside Live Tool Laser" fullWidth/>
                                </Grid>
                                <Grid item xs={5}>
                                    <CustomSelect
                                        source="machine_pattern_type_id"
                                        label="Machine Pattern Type"
                                        resource={"custom-pricing/machine-pattern-types"}
                                        optionValue="id"
                                        fullWidth
                                        defaultValue={record?.machine_pattern_type_id}
                                        validate={validateRequired}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <CustomSelect
                                        source="school"
                                        label="School"
                                        resource={"schools"}
                                        optionValue="id"
                                        fullWidth
                                        validate={validateRequired}
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <AppMultiSelect
                                        reference={"custom-pricing/profiles"}
                                        label="Profiles Allowed"
                                        source="profiles_allowed"
                                        optionValue="id"
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <AppMultiSelect
                                        reference={"custom-pricing/ring-materials"}
                                        label="Ring Materials Allowed"
                                        source="ring_materials_allowed"
                                        optionValue="id"
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <AppMultiSelect
                                        reference={"custom-pricing/inlays"}
                                        label="Inlays Allowed"
                                        source="inlays_allowed"
                                        optionValue="id"
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <AppMultiSelect
                                        reference="custom-pricing/sleeves"
                                        label="Sleeves Allowed"
                                        source="sleeves_allowed"
                                        optionValue="id"
                                    />
                                </Grid>
                                <Grid item xs={5}>
                                    <AppMultiSelect
                                        reference={"school-cerakote-colors"}
                                        label="Cerakote Colors Allowed"
                                        source="cerakote_colors_allowed"
                                        optionValue="id"
                                    />
                                </Grid>
                            </Grid>
                        </SimpleForm>
                    )}
                </WithProps>
            </Edit>
            <Notification />
        </ThemeProvider>
    );
};

export default CollegiateEngravingEdit;


